export enum PublicProjectParams {
  uuid = "uuid",
}
